import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import MarketingHomeBannerBlockData from '../../../Models/Content/MarketingHomeBannerBlockData';
import MarketingHomeBannerBlock from './MarketingHomeBannerBlock';

export default class MarketingHomeBannerBlockComponent extends EpiComponent<MarketingHomeBannerBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <MarketingHomeBannerBlock context={this.getContext()} iContent={this.props.data} />;
  }
}

